import React, { Fragment } from 'react'
import Clear from '@material-ui/icons/Clear'
import ErrorOutlineIcon from '@material-ui/icons/ErrorOutline'
import { StyledButton } from '../../../theme/Global'
import { StyledDialogTitle, StyledDialogContent, TitleContainer, ButtonContainer } from './styles'

export const CSVDownloadErrorPopup = ({ handleClose }) => {
  return (
    <Fragment>
      <StyledDialogTitle>
        <TitleContainer>
          <ErrorOutlineIcon style={{ marginRight: '10px' }} />
          System Error
        </TitleContainer>
        <Clear
          onClick={handleClose}
          style={{ cursor: 'pointer' }}
        />
      </StyledDialogTitle>
      <StyledDialogContent>
        <p>
          Sorry! There was a system error creating your CSV.
          Please contact your Account Manager for help.
        </p>
        <ButtonContainer>
          <StyledButton color="secondary" variant="contained" onClick={() => handleClose()}>
            OK
          </StyledButton>
        </ButtonContainer>
      </StyledDialogContent>
    </Fragment>
  )
}
